(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moeka-desk-world"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.moeka-dwc[data-dwc]').forEach(function (root) {
    var dataEl = root.querySelector('[data-dwc-worlds]');
    if (!dataEl) return;
    var worlds;
    try { worlds = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!worlds.length) return;

    var scene = root.querySelector('[data-dwc-scene]');
    var sceneImage = root.querySelector('[data-dwc-scene-image]');
    var showcase = root.querySelector('[data-dwc-showcase]');
    var worldImage = root.querySelector('[data-dwc-image]');
    var worldNumber = root.querySelector('[data-dwc-number]');
    var worldTitle = root.querySelector('[data-dwc-title]');
    var worldDesc = root.querySelector('[data-dwc-desc]');
    var worldCta = root.querySelector('[data-dwc-cta]');
    var list = root.querySelector('[data-dwc-list]');
    var stepper = root.querySelector('[data-dwc-stepper]');
    var activeIndex = parseInt(root.getAttribute('data-dwc-active') || '0', 10);
    if (isNaN(activeIndex) || activeIndex >= worlds.length) activeIndex = 0;
    var switchTimer;

    worlds.forEach(function (world, index) {
      var button = document.createElement('button');
      button.className = 'world-button';
      button.type = 'button';
      button.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
      button.innerHTML = '<span class="world-index">' + world.number + '</span><span></span>';
      button.lastElementChild.textContent = world.name;
      button.addEventListener('click', function () { selectWorld(index); resetAuto(); });
      list.appendChild(button);

      var dot = document.createElement('button');
      dot.className = 'step-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', world.name);
      dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      dot.addEventListener('click', function () { selectWorld(index); resetAuto(); });
      stepper.appendChild(dot);
    });

    function revealActiveButton(index, behavior) {
      if (window.innerWidth > 820) return;
      var button = list.children[index];
      if (!button) return;
      var target = button.offsetLeft - (list.clientWidth - button.offsetWidth) / 2;
      list.scrollTo({ left: target, behavior: behavior || 'auto' });
    }
    revealActiveButton(activeIndex);

    function selectWorld(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      var world = worlds[index];
      clearTimeout(switchTimer);
      showcase.classList.add('is-switching');
      switchTimer = setTimeout(function () {
        root.style.setProperty('--world', world.color);
        root.style.setProperty('--world-soft', world.soft);
        root.style.setProperty('--overlay', world.overlay);
        if (sceneImage) sceneImage.style.backgroundImage = 'url("' + world.image + '")';
        if (scene) scene.style.backgroundColor = world.soft;
        var grid = scene ? scene.querySelector('.scene-grid') : null;
        if (grid) grid.style.opacity = index === 2 ? '.22' : '.36';
        var badge = scene ? scene.querySelector('.scene-badge') : null;
        if (badge) badge.style.background = index === 2 ? '#f6e36b' : '#75d7c7';
        if (worldImage) { worldImage.src = world.image; worldImage.alt = world.alt; }
        if (worldNumber) worldNumber.textContent = 'WORLD ' + world.number;
        if (worldTitle) worldTitle.innerHTML = '';
        if (worldTitle) {
          worldTitle.appendChild(document.createTextNode(world.name));
          var ja = document.createElement('span');
          ja.className = 'world-title-ja';
          ja.textContent = world.ja;
          worldTitle.appendChild(ja);
        }
        if (worldDesc) worldDesc.textContent = world.description;
        if (worldCta) worldCta.href = world.url;
        Array.prototype.forEach.call(list.children, function (btn, i) { btn.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
        Array.prototype.forEach.call(stepper.children, function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
        revealActiveButton(index, 'smooth');
        showcase.classList.remove('is-switching');
      }, 170);
    }

    if (scene) {
      scene.addEventListener('pointermove', function (event) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var rect = scene.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - .5;
        var y = (event.clientY - rect.top) / rect.height - .5;
        if (sceneImage) sceneImage.style.transform = 'scale(1.035) translate(' + (x * -8) + 'px,' + (y * -8) + 'px)';
      });
      scene.addEventListener('pointerleave', function () {
        if (sceneImage) sceneImage.style.transform = 'scale(1.015)';
      });
    }

    /* ── 自動切り替え ──
       原則: reduced-motion では動かさない / ホバー・フォーカス中は止める /
       タブ非表示・画面外では回さない / 手動操作後はフル間隔に戻す */
    var AUTO_MS = parseInt(root.getAttribute('data-dwc-autoplay') || '0', 10);
    var autoTimer = null;
    var paused = false;
    var inView = true;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function startAuto() {
      if (autoTimer || AUTO_MS <= 0 || reduced.matches) return;
      autoTimer = setInterval(function () {
        if (paused || document.hidden || !inView) return;
        selectWorld((activeIndex + 1) % worlds.length);
      }, AUTO_MS);
    }
    function resetAuto() { stopAuto(); startAuto(); }

    root.addEventListener('pointerenter', function () { paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.25 }).observe(root);
    }
    if (reduced.addEventListener) {
      reduced.addEventListener('change', function (e) { e.matches ? stopAuto() : startAuto(); });
    }
    startAuto();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moeka-edit-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mq(query) { return window.matchMedia ? window.matchMedia(query) : { matches: false }; }
    function init(root) {
      if (!root || root.dataset.moekaEditsReady) return;
      var track = root.querySelector('[data-moeka-edits-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-moeka-edits-slide]'));
      var controls = root.querySelector('[data-moeka-edits-controls]');
      if (!track || !controls || slides.length < 2) return;
      root.dataset.moekaEditsReady = '1';
      var n = slides.length;
      var dotsWrap = root.querySelector('[data-moeka-edits-dots]');
      var bar = root.querySelector('[data-moeka-edits-bar]');
      var curEl = root.querySelector('[data-moeka-edits-current]');
      var totalEl = root.querySelector('[data-moeka-edits-total]');
      var pauseBtn = root.querySelector('[data-moeka-edits-pause]');
      var prevBtn = root.querySelector('[data-moeka-edits-prev]');
      var nextBtn = root.querySelector('[data-moeka-edits-next]');
      var reduce = mq('(prefers-reduced-motion: reduce)').matches;
      var mobile = mq('(max-width: 749px)');
      var delay = parseInt(root.dataset.autoplay, 10) || 0;
      var paused = reduce || !delay;
      var touching = false, hovering = false, focused = false;
      var timer = null, raf = 0, index = 0, dir = 1, fits = false, wrapping = false;
      var dotLabel = root.dataset.dotLabel || 'Show banner';
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (slide, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'moeka-edits__dot';
          b.setAttribute('aria-label', dotLabel + ' ' + (i + 1) + ' / ' + n);
          b.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      if (pauseBtn && (reduce || !delay)) pauseBtn.hidden = true;

      function pos(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
      function measure() {
        fits = track.scrollWidth - track.clientWidth < 8;
        controls.hidden = fits;
        if (totalEl) totalEl.textContent = String(n);
      }
      function paint() {
        var x = track.scrollLeft, best = 0, bestD = Infinity;
        for (var i = 0; i < n; i++) {
          var d = Math.abs(pos(i) - x);
          if (d < bestD) { bestD = d; best = i; }
        }
        index = best;
        for (var j = 0; j < n; j++) slides[j].classList.toggle('is-active', j === index);
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
        if (curEl) curEl.textContent = String(index + 1);
        if (bar) bar.style.transform = 'translateX(' + (index * 100) + '%)';
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === n - 1;
      }
      function go(i, instant) {
        var k = Math.max(0, Math.min(n - 1, i));
        track.scrollTo({ left: pos(k), behavior: instant || reduce ? 'auto' : 'smooth' });
      }
      // スマホは最後の1枚の次に、ふっと消して1枚目へ戻す（試作どおり）
      function wrapToFirst() {
        if (reduce) { go(0, true); return; }
        if (wrapping) return;
        wrapping = true;
        track.classList.add('is-wrapping');
        window.setTimeout(function () {
          go(0, true);
          paint();
          window.requestAnimationFrame(function () { track.classList.remove('is-wrapping'); wrapping = false; });
        }, 420);
      }
      // PC の自動送りは端で向きを変える（試作どおり）。手で押した時は次の1枚へ
      function advance(auto) {
        if (mobile.matches) {
          if (index >= n - 1) wrapToFirst(); else go(index + 1);
          return;
        }
        if (!auto) { go(index + 1); return; }
        if (index >= n - 1) dir = -1; else if (index <= 0) dir = 1;
        go(index + dir);
      }
      function tick() {
        if (paused || fits || document.hidden || touching || hovering || focused) return;
        advance(true);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function restart() { stop(); if (delay && !reduce && !paused) timer = window.setInterval(tick, delay); }
      function label() {
        if (!pauseBtn) return;
        var text = paused ? (pauseBtn.dataset.labelPlay || 'Play') : (pauseBtn.dataset.labelPause || 'Pause');
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', text);
        pauseBtn.setAttribute('title', text);
      }

      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = 0; paint(); });
      }, { passive: true });
      // 送りを待たせるのは「バナーを触っている・バナーにフォーカスがある・マウスがバナーの上にある」間だけ。
      // 下のボタンは対象にしない（ボタンの上にマウスを置いたままでも、押した結果がすぐ見えるように）
      track.addEventListener('pointerdown', function () { touching = true; }, { passive: true });
      ['pointerup', 'pointercancel'].forEach(function (type) {
        window.addEventListener(type, function () { if (touching) { touching = false; restart(); } }, { passive: true });
      });
      track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; }, { passive: true });
      track.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hovering = false; }, { passive: true });
      track.addEventListener('focusin', function () { focused = true; });
      track.addEventListener('focusout', function () { focused = false; });
      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); restart(); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        paused = !paused;
        label();
        if (paused) { stop(); return; }
        // 再生を押したら、すぐ次の1枚へ送って「動いた」ことが分かるようにする
        advance(true);
        restart();
      });
      window.addEventListener('resize', function () { measure(); paint(); }, { passive: true });
      // テーマエディタでブロックを選んだら、そのバナーへ送って止める
      document.addEventListener('shopify:block:select', function (e) {
        var target = e.target && e.target.closest ? e.target.closest('[data-moeka-edits-slide]') : null;
        var i = slides.indexOf(target);
        if (i < 0) return;
        paused = true;
        label();
        stop();
        go(i, true);
      });

      measure();
      paint();
      label();
      root.classList.add('is-ready');
      restart();
    }
    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-moeka-edits]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
